import { pipelineStatusDisplayOptions } from '@/features/dashboard/components/dashboardStatusDataHelpers';
import {
  mapStatusOptionsToMetricOptions,
  resolveMetricTone,
  type MetricCardOption,
} from '@/features/metrics/components/statusMetricCards';
import {
  buildStatusOptions,
  suiteExecutionSummaryStatusOptions,
  testExecutionSummaryStatusOptions,
} from '@/shared/constants/statusOptions';
import { formatStatusLabel } from '@/ui/primitives';
import type {
  PipelineStatusKey,
  SuiteStatusKey,
  TestStatusKey,
} from '@/features/dashboard/components/dashboardStatusDataHelpers';
import type { BuildStatus } from '@flowqa/shared';

export const buildSuiteMetricOptions = (): Array<MetricCardOption<SuiteStatusKey>> => {
  const baseOptions = mapStatusOptionsToMetricOptions(
    suiteExecutionSummaryStatusOptions,
    resolveMetricTone,
  ) as Array<MetricCardOption<SuiteStatusKey>>;
  return [
    ...baseOptions,
    {
      value: 'untested',
      label: formatStatusLabel('untested'),
      tone: resolveMetricTone('untested'),
    },
  ];
};

export const buildTestMetricOptions = (): Array<MetricCardOption<TestStatusKey>> => {
  const baseOptions = mapStatusOptionsToMetricOptions(
    testExecutionSummaryStatusOptions,
    resolveMetricTone,
  ) as Array<MetricCardOption<TestStatusKey>>;
  return [
    ...baseOptions,
    {
      value: 'untested',
      label: formatStatusLabel('untested'),
      tone: resolveMetricTone('untested'),
    },
  ];
};

export const buildPipelineMetricOptions = (): Array<MetricCardOption<PipelineStatusKey>> => {
  const orderedPipelineOptions: Array<{
    value: Exclude<PipelineStatusKey, 'none'>;
    label: string;
  }> = pipelineStatusDisplayOptions.filter(
    (option): option is { value: Exclude<PipelineStatusKey, 'none'>; label: string } =>
      option.value !== 'none',
  );
  const baseOptions = mapStatusOptionsToMetricOptions(
    orderedPipelineOptions,
    resolveMetricTone,
  ) as Array<MetricCardOption<PipelineStatusKey>>;
  return [...baseOptions, { value: 'none', label: 'No Builds', tone: resolveMetricTone('none') }];
};

export const buildBuildMetricOptions = (): Array<MetricCardOption<BuildStatus>> =>
  mapStatusOptionsToMetricOptions(buildStatusOptions, resolveMetricTone);
